module.exports = __webpack_public_path__ + "static/media/header.8b3b85d4.png";